import * as React from 'react';
import { connect } from 'react-redux';
import PasswordManagementForm from './../../Layout/Form/PasswordManagementForm';
import * as UserModule from './../../../Modules/UserModule';

type Props = {};

type ConnectedDispatch = {
    changePassword: Function;
};
type ConnectedProps = {
    UserStore: UserModule.Types.UserStore;
};
type State = {
    //
};

class PasswordManagement extends React.Component<Props & ConnectedDispatch & ConnectedProps, State> {
    constructor(props: Props & ConnectedDispatch & ConnectedProps) {
        super(props);
        this.changePassword = this.changePassword.bind(this);
    }
    private async changePassword(formData: UserModule.Types.ChangePasswordRequest) {
        await this.props.changePassword({ newPassword: formData.newPassword, oldPassword: formData.oldPassword });
    }
    public render() {
        return (
            <div className="login">
                <div className="login__inner">
                    <PasswordManagementForm onSubmit={this.changePassword} />
                </div>
            </div>
        );
    }
}
function mapStateToProps(state: any) {
    return {
        UserStore: state.userStore
    };
}
function mapDispatchToProps(dispatch: any): ConnectedDispatch {
    return {
        changePassword: (formData: UserModule.Types.ChangePasswordRequest) => dispatch(UserModule.Actions.changePassword(formData))
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PasswordManagement) as React.ComponentClass<Props>;



// WEBPACK FOOTER //
// ./src/components/Account/PasswordManagement/PasswordManagement.tsx